import { useMyMeasuring, openRecorder, loadActive } from './store';

// The Measuring card on Today: there only when something has been given to
// you today (the director, 7 Oct 2026). Start opens the recorder at it.

const TEAL = '#14b8a6', GREEN = '#34d399', DIM = '#9ca3af';

export default function TodayCard() {
  const mine = useMyMeasuring();
  const tasks = mine.tasks || [];
  if (!tasks.length) return null;
  const active = loadActive();
  const todo = tasks.filter(t => t.status === 'assigned').length;
  return (
    <div style={{ background: '#1e2329', border: `1px solid ${TEAL}55`, borderRadius: 12, padding: '12px 14px', marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 8, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 800, color: TEAL, letterSpacing: '0.04em', fontSize: 13 }}>MEASURING</span>
        <span style={{ fontSize: 13, color: DIM }}>{todo ? `${todo} to measure today` : 'All measured today. Thank you.'}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {tasks.map(t => {
          const running = active && active.taskId === t.id;
          const done = t.status === 'done';
          return (
            <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5 }}>
              <span style={{ flex: 1, minWidth: 0, color: done ? DIM : '#f0f2f5' }}>
                {t.title}
                {t.source === 'asked' && <span style={{ display: 'block', fontSize: 12, color: DIM }}>{t.why}</span>}
              </span>
              {done
                ? <span style={{ fontSize: 12, fontWeight: 700, color: GREEN }}>Done</span>
                : <button onClick={() => openRecorder(t.id)}
                    style={{ background: running ? 'none' : TEAL, color: running ? TEAL : '#0b1215', border: `1px solid ${TEAL}`, borderRadius: 8, padding: '6px 14px', fontWeight: 700, cursor: 'pointer' }}>
                    {running ? 'Continue' : 'Start'}
                  </button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
